var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1839_72629)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0607 14.9393C15.6464 15.5251 15.6464 16.4749 15.0607 17.0607L8.12132 24L15.0607 30.9393C15.6464 31.5251 15.6464 32.4749 15.0607 33.0607C14.4749 33.6464 13.5251 33.6464 12.9393 33.0607L4.93934 25.0607C4.35355 24.4749 4.35355 23.5251 4.93934 22.9393L12.9393 14.9393C13.5251 14.3536 14.4749 14.3536 15.0607 14.9393Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9393 14.9393C33.5251 14.3536 34.4749 14.3536 35.0607 14.9393L43.0607 22.9393C43.6464 23.5251 43.6464 24.4749 43.0607 25.0607L35.0607 33.0607C34.4749 33.6464 33.5251 33.6464 32.9393 33.0607C32.3536 32.4749 32.3536 31.5251 32.9393 30.9393L39.8787 24L32.9393 17.0607C32.3536 16.4749 32.3536 15.5251 32.9393 14.9393Z",
    fill: "#2C3E50"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3637 6.54477C29.1674 6.7457 29.656 7.5601 29.4551 8.36379L21.4551 40.3638C21.2542 41.1675 20.4398 41.6561 19.6361 41.4552C18.8324 41.2543 18.3437 40.4399 18.5447 39.6362L26.5447 7.63619C26.7456 6.83249 27.56 6.34385 28.3637 6.54477Z",
    fill: "#2C3E50"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1839_72629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon4);
export default __webpack_public_path__ + "static/media/file-icon-4.609d7f7cb4271821672d712713025bf0.svg";
export { ForwardRef as ReactComponent };